import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentInjuriesPath} from './PropertyPaths/accidentInjuriesPath';

export const GunshotWound = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentInjuriesPath(selectedPlan?.planIndex || 0, 0);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'gunshot-wound-row-1'},
      items: [
        {
          key: propertyPaths.gunshotWoundDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Hours)"
              value={getQuoteFieldValue<number>(propertyPaths.gunshotWoundDetails.incurralPeriod)}
              disabled
              id={propertyPaths.gunshotWoundDetails.incurralPeriod}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.gunshotWoundDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.gunshotWoundDetails.customizeBenefitAmount)}
              id={propertyPaths.gunshotWoundDetails.customizeBenefitAmount}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'gunshot-wound-row-2'},
      items: [
        {
          key: propertyPaths.gunshotWoundDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              adornment="money"
              value={formatCurrencyValue(getQuoteFieldValue<number>(propertyPaths.gunshotWoundDetails.benefitAmount))}
              disabled
              id={propertyPaths.gunshotWoundDetails.benefitAmount}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.gunshotWoundDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`ACCGunshotWoundBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(propertyPaths.gunshotWoundDetails.maxBenefitNumber)}
              disabled
              id={propertyPaths.gunshotWoundDetails.maxBenefitNumber}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'gunshot-wound-row-3'},
      items: [
        {
          key: propertyPaths.gunshotWoundDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={`ACCGunshotWoundBenefit.timePeriodCd`}
              label="Time Period"
              value={getQuoteFieldValue<string>(propertyPaths.gunshotWoundDetails.timePeriodCd)}
              disabled
              id={propertyPaths.gunshotWoundDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
